import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import BackBtn from "../../../library/custom/backBtn/backBtn";
import UserQuizDetail from "../component/userQuizDetail/userQuizDetail";
import { useDispatch, useSelector } from "react-redux";
import * as quizAction from "../../../redux/actions/quizAction";
import { useLocation } from "react-router-dom";
import Loader from "../../../library/common/Loader";
import { API_STATUS } from "../../../constant/constant";
import SuccessScreen from "../../../library/custom/success/successScreen";
import { quizImg } from "../../../assets";
import { checkPrivileges } from "../../../utils/rolesHelper";
import {
  ACCESS_DENIED,
  COURSESDETAIL,
  LESSONDETAIL,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";

const UserQuizContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const quizId = location?.state?.quizId;
  const lessonId = location?.state?.lessonId;
  const courseId = location?.state?.courseId;
  const isAdminLms = location?.state?.isAdminLms;
  const isMapping =
    location?.state?.isMapping || location?.state?.fromReportAnalytics;
  const [errCompltemsg, setErrCompltemsg] = useState("");
  const [isclickbtn, setIsclickbtn] = useState(false);
  const quizListData = useSelector((state) => state.getQuizList);
  const navigate = useNavigate();
  console.log("Location UserQuizContainer", location);
  const dataBack = {
    title: location?.state?.routeText
      ? location?.state?.routeText
      : "Back to Lesson",
    route: location?.state?.courseDetailBackPath1
      ? location?.state?.courseDetailBackPath1
      : -1,
    state: {
      removeSceenLessonId: lessonId,
      removeSceenValue: location?.state?.value,
      fromReportAnalytics: location?.state?.fromReportAnalytics,
      courseId: courseId,
      prevPath: location.state?.prevPath,
      courseDetailBackPath: location?.state?.courseDetailBackPath,
      isAdminLms: location?.state?.isAdminLms,
      isAdminCourse: location?.state?.isAdminCourse,
      page: location?.state?.page,
      apiData: location?.state?.apiData,
    },
  };
  const defaultData = {
    quizId: quizId,
    lessonId: lessonId,
    courseId: courseId,
  };

  const submitQuiz = useSelector((state) => state.submitQuiz);
  const submitQuizCode = useSelector(
    (state) => state.submitQuiz.data?.responseMessages?.responseCode
  );
  const submitQuizMsg = useSelector(
    (state) => state.submitQuiz.data?.responseMessages?.responseMessage
  );

  const statuss = submitQuiz?.status;
  const SubisLoading = submitQuiz?.isLoading;

  const qShowStatus = submitQuiz?.data?.result;
  const route = location?.state?.prevPath ? location?.state?.prevPath : -1;

  const getRouteForQuizResult = (quizStatus) => {
    if (quizStatus === "Passed!") {
      return route;
    }
    if (courseId) {
      return COURSESDETAIL;
    } else if (lessonId) {
      return LESSONDETAIL;
    }
    return route;
  };

  const [successScreens, setSuccessScreens] = useState(false);

  const addSubmitQuiz = async (data) => {
    setSuccessScreens(true);
    dispatch(quizAction.submitQuiz(data));
  };

  const getQuizListData = (data) => {
    dispatch(quizAction.getQuizList(data));
  };

  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10, 9]);

    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    // if (!location?.state?.quizId) { TODO
    //   navigate(DASHBOARD);
    // }
    getQuizListData(defaultData);
    setErrCompltemsg("");
  }, []);

  const isLoading = useSelector((state) => state.getQuizList?.isLoading);

  const successScree = (qShowStatus) => {
    const routeForQuizResult = getRouteForQuizResult(qShowStatus);
    const getRouteState = () => {
      if (qShowStatus === "Passed!") {
        return {
          value: location?.state?.value ?? "",
          removeSceenLessonId: lessonId,
          prevPath: location.pathname,
          courseDetailBackPath: location?.state?.courseDetailBackPath,
        };
      }

      if (courseId) {
        return {
          courseId: courseId,
          isAdminCourse: isAdminLms,
          fromReportAnalytics: location?.state?.fromReportAnalytics,
          page: location?.state?.page,
          apiData: location?.state?.apiData,
        };
      } else if (lessonId) {
        return {
          lessonId: lessonId,
          isAdminLesson: isAdminLms,
          fromReportAnalytics: location?.state?.fromReportAnalytics,
          page: location?.state?.page,
          apiData: location?.state?.apiData,
        };
      }
      return {
        value: location?.state?.value ?? "",
        removeSceenLessonId: lessonId,
      };
    };

    return (
      <SuccessScreen
        route={routeForQuizResult}
        routeState={getRouteState()}
        isClass={qShowStatus === "Passed!" ? "passed" : "failed"}
        isImg={qShowStatus === "Passed!" ? quizImg?.passed : quizImg?.failed}
        label1={qShowStatus}
        label2={
          qShowStatus === "Passed!"
            ? "Congrats! You have successfully completed the Lesson"
            : "Cheer up! Redo the lesson and take the quiz again !"
        }
        value={location?.state?.value ?? ""}
        removeSceenLessonId={lessonId}
        isQuizScreen={true}
        id={courseId}
        prevPath={location.pathname}
        courseDetailBackPath={location?.state?.courseDetailBackPath}
        // setremoveSceenValue={props?.setremoveSceenValue}
        // setRemoveSceenLessonId={setRemoveSceenLessonId}
      ></SuccessScreen>
    );
  };
  useEffect(() => {
    if (statuss == "SUCCESS" && submitQuizCode == "HBNG002" && isclickbtn) {
      setErrCompltemsg(submitQuizMsg);
      setIsclickbtn(false);
    }
  }, [SubisLoading, submitQuiz]);

  return (
    <>
      {statuss == API_STATUS.SUCCESS &&
      successScreens &&
      submitQuizCode == "HBNG001" ? (
        successScree(qShowStatus)
      ) : (
        <div className="createQuizContainer">
          <Grid container>
            <BackBtn dataBack={dataBack} />
          </Grid>
          <Grid container>
            {isLoading || SubisLoading ? (
              <Loader />
            ) : (
              <UserQuizDetail
                quizListData={quizListData.data}
                getQuizListData={getQuizListData}
                onSubmit={addSubmitQuiz}
                lessonId={lessonId}
                courseId={courseId}
                errCompltemsg={errCompltemsg}
                setIsclickbtn={setIsclickbtn}
                isAdminLms={isAdminLms}
                isMapping={isMapping}
              />
            )}
          </Grid>
        </div>
      )}
    </>
  );
};

export default UserQuizContainer;
